import React from "react";
import { Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ConfirmDialog } from "src/apps/commons/dataDisplays";
import { PartnerUserId as ID } from "../types";
import Form from "./ChangePasswordForm";
import { useChangePassword } from "../hooks";

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    padding: "16px"
  }
}));

interface Props {
  id: ID;
}

const Containers: React.FC<Props> = props => {
  const { id } = props;

  const classes = useStyles();

  const {
    fetching,
    saving,
    confirmDialogState,
    handleSave,
    handleCloseDialog
  } = useChangePassword(id);

  return (
    <Paper className={classes.root}>
      <Form isLoading={fetching} isSaving={saving} onSubmit={handleSave} />

      <ConfirmDialog
        title={`ยืนยันการเปลี่ยน Password?`}
        open={confirmDialogState.open}
        onClose={handleCloseDialog}
        onConfirm={confirmDialogState.onConfirm}
      />
    </Paper>
  );
};

export default Containers;
